import { FC, ReactNode } from 'react';
import { Card } from '@/components/ui/card';

interface GameLayoutProps {
  children: ReactNode;
  title: string;
  description: string;
}

export const GameLayout: FC<GameLayoutProps> = ({ children, title, description }) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8 text-center">
          <h1 className="text-4xl font-bold mb-2">{title}</h1>
          <p className="text-lg text-gray-600">{description}</p>
        </div>
        
        <Card className="p-6">
          {children}
        </Card>
      </div>
    </div>
  );
};
